<template>
    <div class="top">
        <img src="https://umed.oss-cn-hangzhou.aliyuncs.com/say/top.png" alt="top">
    </div>
</template>

<script>
    export default {
        name: "Top"
    }
</script>

<style scoped lang="scss">
    .top img{
        width: 100%;
        height: auto;
    }
</style>
